import React from "react";

const CredentialContext = React.createContext({
  credential: null,
  setCredential: () => {},
});

export default CredentialContext;